import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Text from '@clearscore/rainbow.text';
import toTitleCase from '@clearscore/normalize.title-case';

import { themes } from './constants';
import styles from './tag.css';

const Tag = ({ text, theme, isFullWidth, dataId }) => (
    <div
        className={cx(styles.component, styles[`isTheme${toTitleCase(theme)}`], { [styles.isFullWidth]: isFullWidth })}
        data-qa="tag"
        data-id={dataId}
    >
        <Text.Overline>{text}</Text.Overline>
    </div>
);

Tag.propTypes = {
    text: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(Object.values(themes)),
    isFullWidth: PropTypes.bool,
    dataId: PropTypes.string,
};

Tag.defaultProps = {
    theme: themes.DEFAULT,
    isFullWidth: false,
    dataId: undefined,
};

Tag.themes = themes;

export default Tag;
